function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -996.362)",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 1013.362h19v28H20zM18 1017.362h2v9h-2zM16 1019.362h2v5h-2zM41 1017.362h-2v9h2zM43 1019.362h-2v5h2z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 3,
  x: 16,
  y: 1044.362,
  rx: 0.931,
  ry: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 3,
  x: 17,
  y: 1041.362,
  rx: 0.793,
  ry: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 3,
  x: 18,
  y: 1010.362,
  rx: 0.793,
  ry: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.75 1010.362h-18.5s1.682-5.305 9.25-5.305 9.25 5.305 9.25 5.305zM31.125 1005.041h-3.25s.295-2.079 1.625-2.079 1.625 2.08 1.625 2.08z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.5 1021.962a3 3 0 11-6 0 3 3 0 116 0z",
  strokeWidth: 0.9997499999999999
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 1021.962a5 5 0 11-10 0 5 5 0 1110 0z"
}));

var SvgFirehydrant = function SvgFirehydrant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFirehydrant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Firehydrant.3a75a54c.svg";
export { ForwardRef as ReactComponent };